export default {"src":"/_next/static/media/car-shield-white.5f143201.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};